"use client";

import * as React from 'react';
import classNames from 'classnames';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const NavbarText = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    bsPrefix,
    as: Component = 'span',
    ...props
  } = _ref;
  bsPrefix = useBootstrapPrefix(bsPrefix, 'navbar-text');
  return /*#__PURE__*/_jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
NavbarText.displayName = 'NavbarText';
export default NavbarText;